import { useEffect, useState } from "react";
import { getUserScreenPermission } from "../utils/screenPermission";
import { logOut } from "../components/Logout";

export const useScreenPermission = (screenName, navigate) => {
  const [permission, setPermission] = useState({
    view: false,
    edit: false,
    add: false,
    full: false,
    accessLevel: "None",
  });

  const [permissionLoading, setPermissionLoading] = useState(true);

  useEffect(() => {
    if (screenName) {
      setPermissionLoading(true);

      getUserScreenPermission(screenName)
        .then((result) => {
          setPermission(
            result || {
              view: false,
              edit: false,
              add: false,
              full: false,
              accessLevel: "None",
            },
          );
          setPermissionLoading(false);
        })
        .catch((error) => {
          setPermission({
            view: false,
            edit: false,
            add: false,
            full: false,
            accessLevel: "None",
          });

          setPermissionLoading(false);

          if (!error?.response) {
            navigate("/error/500");
          } else if (error?.response?.status === 401) {
            logOut();
          }
        });
    }
  }, [screenName, navigate]);

  return { permission, permissionLoading };
};
